import { NgModule } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";

import { MatCoreModule } from "./material/mat-core.module";

import { CountdownModule } from "ngx-countdown";
// import { ChartsModule } from "ng2-charts";

import { ConfirmModalComponent } from "./components/confirm-modal/confirm-modal.component";
import { ModalService } from "./services/modal.service";
import { MessageModalComponent } from "./components/message-modal/message-modal.component";
import { JalaliPipe } from "./pipe/jalali.pipe";
import { PortComponentComponent } from "./components/port-component/port-component.component";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from "@angular/material/input";
import { MatDialogModule } from '@angular/material/dialog';
import { ModalComponent } from "./components/modal/modal.component";
import { CustomsComponent } from "./components/customs/customs.component";

const UIKIT = [ConfirmModalComponent, MessageModalComponent];

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CountdownModule,
    MatCoreModule,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
  ],
  declarations: [
    ...UIKIT,
    JalaliPipe,
    PortComponentComponent,
    CustomsComponent,
    ModalComponent
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CountdownModule,
    ...UIKIT,
    MatCoreModule,
    JalaliPipe,
    PortComponentComponent,
    CustomsComponent
  ],
  providers: [ModalService],
})
export class SharedModule { }
